module.exports = __webpack_public_path__ + "img/picto-7.591f8da7.png";